import agentsData from '@/json/agents.json';

interface AgentVariantConfig {
  id: string;
  name: string;
  agentId: string;
  language: string;
}

interface AgentUseCaseConfig {
  displayName?: string;
  [variantKey: string]: AgentVariantConfig | string | undefined;
}

const GENDER_TO_VARIANT_KEY: Record<string, string> = {
  male: 'virtufy-male',
  female: 'virtufy-female',
};

const isAgentVariantConfig = (value: unknown): value is AgentVariantConfig => (
  typeof value === 'object' &&
  value !== null &&
  'agentId' in value &&
  'id' in value &&
  'name' in value &&
  'language' in value
);

export interface ResolvedAgentConfig {
  agentId: string;
  agentName?: string;
}

export const resolveAgentByGender = (
  useCaseKey: string,
  gender?: string | null,
): ResolvedAgentConfig | undefined => {
  if (!gender) {
    return undefined;
  }

  const normalizedGender = gender.toLowerCase();
  const variantKey = GENDER_TO_VARIANT_KEY[normalizedGender];
  if (!variantKey) {
    return undefined;
  }

  const useCase = (agentsData as Record<string, AgentUseCaseConfig | undefined>)[useCaseKey];
  if (!useCase) {
    return undefined;
  }

  const variant = useCase[variantKey];
  if (!isAgentVariantConfig(variant)) {
    return undefined;
  }

  return {
    agentId: variant.agentId,
    agentName: variant.name ?? useCase.displayName,
  };
};

